// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import DefaultButton from './../../../../../../components/DefaultButton';
import TextInput from './../../../../../../components/TextInput';
import messageManager from './../../../../../../utilities/messageManager';
import loading from './../../../../../../utilities/loading';

const FormContainer = styled.form`
    width: 100%;
    display: flex;
    align-items: center;
`;

const Wrapper = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
`;

const StyledTextInput = styled(TextInput)`
    margin-right: 10px;
`;

class UserCreator extends React.Component {
    constructor() {
        super();
        this.state = {
            forename: '',
            surname: '',
            phoneNumber: '',
            login: '',
            invalidLogin: false,
            invalidForename: false,
            invalidSurname: false,
            createButtonDisabled: false,
        }
    }

    registerUser(userData) {
        const { BASE_URL, axiosInstance, t } = this.props;

        loading.start();
        this.setState({ createButtonDisabled: true })

        axiosInstance.post(`${BASE_URL}account/register`, userData)
            .then((result) => {
                messageManager.show({
                    type: 'info',
                    text: t('User created'),
                });
                loading.stop();
                this.props.getUsers(axiosInstance);
            })
            .catch((error) => {
                messageManager.show({
                    type: 'error',
                    text: t(error.response.data ? error.response.data : t('Error occured while creating user')),
                });
                loading.stop();
            })
            .then(() => {
                this.setState({ createButtonDisabled: false })
            })
    }

    handleSubmit() {
        const { forename, surname, phoneNumber, login } = this.state;
        const { chosenCustomer } = this.props;
        this.validateForm(formInvalid => {
            if (!formInvalid) {
                this.registerUser(
                    {
                        forename: forename,
                        surname: surname,
                        phoneNumber: phoneNumber,
                        login: login,
                        customerId: chosenCustomer.id
                    }
                );
            }
            else {
                this.setState({ createButtonDisabled: false })
            }
        })
    }

    validateForm(callback) {
        const { login, forename, surname } = this.state;

        let invalidLogin = false,
            invalidForename = false,
            invalidSurname = false;

        if (login === "") invalidLogin = true;
        if (forename === "") invalidForename = true;
        if (surname === "") invalidSurname = true;

        this.setState({
            invalidLogin: invalidLogin,
            invalidForename: invalidForename,
            invalidSurname: invalidSurname,
        },
            callback(invalidLogin || invalidForename || invalidSurname));
    }

    render(): React.Node {
        const { t, limitExceeded } = this.props;
        const {
            login,
            forename,
            surname,
            phoneNumber,
            invalidLogin,
            invalidForename,
            invalidSurname,
            createButtonDisabled,
        } = this.state;
        return (
            <Wrapper>
                <FormContainer onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleSubmit();
                }}>
                    <input type="submit" value="Submit" style={{ display: 'none' }} />
                    <StyledTextInput
                        type="email"
                        placeholder="example@mail.com"
                        autoComplete="email"
                        required
                        name="email"
                        value={login}
                        invalid={invalidLogin}
                        onChange={(e) => { this.setState({ login: e.target.value }) }}
                        onBlur={() => {
                            if (login === "") this.setState({ invalidLogin: true })
                            else this.setState({ invalidLogin: false })
                        }}
                    />
                    <StyledTextInput
                        type="text"
                        placeholder={t('First name')}
                        autoComplete="given-name"
                        name="fname"
                        value={forename}
                        invalid={invalidForename}
                        onChange={event => { this.setState({ forename: event.target.value }) }}
                        onBlur={() => {
                            if (forename === "") this.setState({ invalidForename: true })
                            else this.setState({ invalidForename: false })
                        }}
                    />
                    <StyledTextInput
                        type="text"
                        placeholder={t('Last name')}
                        autoComplete="family-name"
                        name="lname"
                        value={surname}
                        invalid={invalidSurname}
                        onChange={event => { this.setState({ surname: event.target.value }) }}
                        onBlur={() => {
                            if (surname === "") this.setState({ invalidSurname: true })
                            else this.setState({ invalidSurname: false })
                        }}
                    />
                    <StyledTextInput
                        type="tel"
                        placeholder={t('Phone')}
                        autoComplete="tel"
                        name="phone"
                        value={phoneNumber}
                        onChange={event => { this.setState({ phoneNumber: event.target.value }) }} />
                    <DefaultButton style={{ minWidth: '104px'}}
                        disabled={createButtonDisabled || limitExceeded}
                        onClick={() => {
                            this.setState({ createButtonDisabled: true })
                            this.handleSubmit();
                        }}>
                        {t('Create user')}
                    </DefaultButton>
                </FormContainer>
            </Wrapper>
        )
    }
}

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(UserCreator));



// WEBPACK FOOTER //
// ./src/containers/content/grid/adminPanel/userAdmin/userCreator/UserCreator.jsx